import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@shopmuchmore/design-system";
import { Trash2 } from "lucide-react";
import { type ReactNode } from "react";

interface DeleteAddressDialogProps {
  onConfirm: () => Promise<void>;
  isLoading?: boolean;
  trigger?: ReactNode;
}

export function DeleteAddressDialog({ onConfirm, isLoading = false, trigger }: DeleteAddressDialogProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        {trigger || (
          <Button variant="ghost" size="sm" className="text-red-500 hover:text-red-600 hover:bg-red-50 h-7 px-2.5 text-xs rounded-full gap-1.5 font-semibold">
            <Trash2 className="w-3.5 h-3.5" />
            Delete
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="rounded-[2.5rem]">
        <DialogHeader>
          <DialogTitle className="text-2xl font-black text-secondary">Delete Address?</DialogTitle>
          <DialogDescription className="text-muted-foreground text-lg italic">
            This action cannot be undone. This will permanently remove this shipping address from your profile.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-8 gap-3">
          <Button
            variant="outline"
            onClick={() => (document.querySelector('[data-state="open"]') as any)?.click()}
            className="rounded-xl h-12 border-destructive text-destructive hover:bg-destructive/10 hover:text-destructive"
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            loading={isLoading}
            onClick={async () => {
              try {
                await onConfirm();
                // Close dialog after successful delete (Radix-way is usually via controlled state, but the template used this click trick)
                (document.querySelector('[data-state="open"]') as any)?.click();
              } catch (error) {
                console.error('Failed to delete address', error);
              }
            }}
            className="rounded-xl h-12 font-bold"
          >
            Yes, Delete Address
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
